var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuperFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,4.29l-1-1-.71-.29H10v-1l-.29-.71-1-1-.71-.29H2l-.71,.29L.29,1.29l-.29,.71V20l.29,.71,1,1,.71,.29H22l.71-.29,1-1,.29-.71V5l-.29-.71Zm-1.71,15.29l-.41,.41H2.41l-.41-.41V2.41l.41-.41H7.59l.41,.41v2.59h13.59l.41,.41v14.17Zm-5-8.59l-3.09,2.25,1.18,3.63-3.09-2.25-3.09,2.25,1.18-3.63-3.09-2.25h3.82l1.18-3.63,1.18,3.63h3.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuperFolder);
export default __webpack_public_path__ + "static/1778142529/media/icon-super-folder.2578e5cfab20faab2f260c0bfca06f76.svg";
export { ForwardRef as ReactComponent };